module.exports = __webpack_public_path__ + "img/02_1_4_1.f4037e00.png";